import { combineReducers } from 'redux';
import { CUSTOMS_VERIFY, NOTIFICATION_FUNCTIONCODE, REALNAME_CANCEL, } from './types';
var realnameCancel = function (state, action) {
    if (state === void 0) { state = { options: [], trans: {} }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case REALNAME_CANCEL:
            return payload;
        default:
            return state;
    }
};
var customsVerify = function (state, action) {
    if (state === void 0) { state = { options: [], trans: {} }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case CUSTOMS_VERIFY:
            return payload;
        default:
            return state;
    }
};
var notificationFunctioncode = function (state, action) {
    if (state === void 0) { state = { options: [], trans: {} }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case NOTIFICATION_FUNCTIONCODE:
            return payload;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'SYSTEM_CODE';
var SYSTEM_CODE = combineReducers({
    realnameCancel: realnameCancel,
    customsVerify: customsVerify,
    notificationFunctioncode: notificationFunctioncode,
});
export default SYSTEM_CODE;
